var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
import { OfficeProductType } from '../enums/office-product-type.enum.js';
export class OfficeProductLineItemResponseDto {
    id;
    createdAt;
    updatedAt;
    title;
    count;
    officeProductId;
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], OfficeProductLineItemResponseDto.prototype, "id", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Date)
], OfficeProductLineItemResponseDto.prototype, "createdAt", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Date)
], OfficeProductLineItemResponseDto.prototype, "updatedAt", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], OfficeProductLineItemResponseDto.prototype, "title", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], OfficeProductLineItemResponseDto.prototype, "count", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], OfficeProductLineItemResponseDto.prototype, "officeProductId", void 0);
export class OfficeProductResponseDto {
    id;
    createdAt;
    updatedAt;
    officeId;
    connectedStripeAccountId;
    name;
    price;
    description;
    image;
    visible;
    type;
    expirationDays;
    therameVideoCallCount;
    therameExerciseProgramCount;
    stripeProductId;
    stripeDefaultPriceId;
    officeProductLineItems;
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], OfficeProductResponseDto.prototype, "id", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Date)
], OfficeProductResponseDto.prototype, "createdAt", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Date)
], OfficeProductResponseDto.prototype, "updatedAt", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], OfficeProductResponseDto.prototype, "officeId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], OfficeProductResponseDto.prototype, "connectedStripeAccountId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], OfficeProductResponseDto.prototype, "name", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], OfficeProductResponseDto.prototype, "price", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], OfficeProductResponseDto.prototype, "description", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], OfficeProductResponseDto.prototype, "image", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], OfficeProductResponseDto.prototype, "visible", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], OfficeProductResponseDto.prototype, "type", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], OfficeProductResponseDto.prototype, "expirationDays", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], OfficeProductResponseDto.prototype, "therameVideoCallCount", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], OfficeProductResponseDto.prototype, "therameExerciseProgramCount", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], OfficeProductResponseDto.prototype, "stripeProductId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], OfficeProductResponseDto.prototype, "stripeDefaultPriceId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Array)
], OfficeProductResponseDto.prototype, "officeProductLineItems", void 0);
//# sourceMappingURL=office-product.response.dto.js.map